import {
  HTTP_STATUS_CODES,
  STATUS_CODES_TYPES,
} from '../../constants/HttpStatusCodes';
import { getLocale, getSessionExpired } from '../storageService/GlobalData';
import localization from '../../localization/i18n';
import { SERVER_STATUS_CODES } from '../../constants/ServerStatusCodes';
import { store } from '../../store/react';
import { navigateTo } from '../../store/actions/navigation';
import RouteConstants from '../../constants/RouteConstants';
import ACTION_CONSTANTS from '../../constants/actionConstants';
import AlertService from '../AlertService';
import { checkSessionExpired } from './reactInterceptor';

function navigateToErrorScreenOnce(route) {
  if (window.location.pathname === route) {
    return;
  }
  const isAlreadyOnErrorScreen =
    window.location.pathname === RouteConstants.SERVER_NOT_RESPONDING ||
    window.location.pathname === RouteConstants.SERVER_ERROR;

  store.dispatch(navigateTo(route, null, isAlreadyOnErrorScreen));
}

export function handleResponse(response) {
  if (HTTP_STATUS_CODES[response.status].type === STATUS_CODES_TYPES.SUCCESS) {
    if (
      response.data.response.success === true ||
      response.data.response.code === SERVER_STATUS_CODES._00001
    ) {
      store.dispatch({
        type: ACTION_CONSTANTS.SET_SERVER_ERROR,
        payload: false,
      });
      return {
        data: response.data.response.PBBeans,
        time: response.data.response.time,
        ts: response.data.response.ts,
        code: response.data.response.code,
      };
    } else {
      throw response;
    }
  } else {
    throw response;
  }
}

export async function handleError(error) {
  if (!error.response && !error.data) {
    navigateToErrorScreenOnce(RouteConstants.SERVER_NOT_RESPONDING);
    throw { message: null };
  } else {
    checkSessionExpired && checkSessionExpired(error) === false;
    if (!getSessionExpired()) {
      if (error.response && error.response.status) {
        if (error.response.status == 404 || error.response.status == 503) {
          navigateToErrorScreenOnce(RouteConstants.SERVER_NOT_RESPONDING);
          throw { message: null };
        }
        if (error.response.status == 500) {
          navigateToErrorScreenOnce(RouteConstants.SERVER_ERROR);
          throw { message: null };
        }
      }
      let errorMessage = {
        message: error.data
          ? error.data.response.code === '_00908'
            ? error.data.response.message
            : (localization[getLocale()][
                'ERROR_CODE' + error.data.response.code
              ] ?? error.data.response.message)
          : localization[getLocale()].SOMETHING_WENT_WRONG,
        code: error.data ? error.data.response.code : null,
        errors: [],
      };
      throw errorMessage;
    } else {
      throw { message: null };
    }
  }
}
